import { controlDefaults } from '../../../../core/form/lib/validateForm';
import { columnWidths } from '../../constants/listviews';

export const controls = {
  id: {
    ...controlDefaults,
    name: 'id',
    type: 'hidden',
  },
  open_date: {
    ...controlDefaults,
    placeholder: '',
    group: 'Agistment Dates',
    name: 'open_date',
    fieldName: 'open_date',
    type: 'date',
    caption: 'Start Date',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  close_date: {
    ...controlDefaults,
    placeholder: '',
    group: 'Agistment Dates',
    name: 'close_date',
    fieldName: 'close_date',
    type: 'date',
    caption: 'End Date',
    validationRules: {},
    showInEditor: true,
    showInListview: true,
  },
  total_weeks_count: {
    ...controlDefaults,
    classes: 'border-start border-end text-end',
    placeholder: '',
    name: 'total_weeks_count',
    type: 'number',
    group: 'Agistment Dates',
    caption: 'Total Number of Weeks',
    validationRules: {},
    formattingRules: {},
    showInEditor: true,
    disabled: true,
    showInListview: true,
    totals: true,
    width: `${columnWidths.common}px`,
  },
  enterprise_id: {
    ...controlDefaults,
    placeholder: '',
    group: 'Animals',
    fieldName: 'enterprise.name',
    name: 'enterprise_id',
    type: 'select',
    caption: 'Enterprise',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  property_id: {
    ...controlDefaults,
    placeholder: '',
    group: 'Animals',
    fieldName: 'property.name',
    name: 'property_id',
    type: 'select',
    caption: 'Property',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  animal_class_id: {
    ...controlDefaults,
    placeholder: '',
    group: 'Animals',
    fieldName: 'animal_class.name',
    name: 'animal_class_id',
    type: 'select',
    caption: 'Animal Class',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  quantity_head: {
    ...controlDefaults,
    placeholder: '',
    group: 'Animals',
    name: 'quantity_head',
    type: 'number',
    caption: '# of Head',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  au_rating_lsu: {
    ...controlDefaults,
    fieldName: 'au_rating_lsu',
    placeholder: '',
    group: 'Animals',
    unitType: 'lsu',
    name: 'au_rating_lsu',
    type: 'number',
    caption: 'AU Rating',
    validationRules: {
      isRequired: true,
    },
    formattingRules: {
      includeDecimals: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  area_ha: {
    ...controlDefaults,
    placeholder: '',
    group: 'Animals',
    name: 'area_ha',
    fieldName: 'area_ha',
    type: 'text',
    caption: 'Area (ha)',
    validationRules: {
      isRequired: true,
    },
    showInEditor: true,
    showInListview: true,
  },
  comments: {
    ...controlDefaults,
    placeholder: 'Comments',
    name: 'comments',
    group: 'Animals',
    type: 'textarea',
    caption: 'Comments',
    persist: false,
    validationRules: {},
    showInEditor: true,
  },
  transaction_type_id: {
    ...controlDefaults,
    placeholder: '',
    name: 'transaction_type_id',
    fieldName: 'transaction_type_id',
    caption: 'Transaction Type',
    disabled: true,
    type: 'select',
    validationRules: {
      isRequired: true,
    },
    showInListview: false,
    showInEditor: false,
  },

  value_per_head_week: {
    ...controlDefaults,
    group: 'Value',
    name: 'value_per_head_week',
    type: 'number',
    caption: 'Value Per Head ($/head/week)',
    validationRules: {
      isRequired: true,
    },
    formattingRules: {
      includeCommas: true,
      includeDollarSign: true,
      includeDecimals: false,
    },
    showInEditor: true,
    showInListview: true,
    tracking: ['amount'],
    user_entry: false,
  },
  total_value: {
    ...controlDefaults,
    placeholder: '',
    group: 'Value',
    name: 'total_value',
    type: 'number',
    formattingRules: {
      includeCommas: true,
      includeDecimals: true,
      includeDollarSign: true,
    },
    caption: 'Total Value ($)',
    disabled: true,
    showInListview: true,
    showInEditor: true,
    totals: true,
    formula: '##total_weeks_count## * ##quantity_head## * ##value_per_head_week##',
  },
};
